module.exports = __webpack_public_path__ + "media/team/philippine-60612ad9.png";